// @ts-strict-ignore
export class CSVUtils {

  public static readonly VALUES_SEPARATOR: string = ';';
  public static readonly LINES_SEPARATOR: string = '\n';
  public static readonly FILE_EXTENSION: string = '.csv';

  public static createContentString(contentObjectArray: any[], contentPropertyNamesArray: string[], valuesSeparator: string = null,
    lineSeparator: string = null, useQuotationMarksForStrings: boolean = false): string {
    let content: string = '';
    if (!contentObjectArray || !contentPropertyNamesArray) {
      return content;
    }
    if (!valuesSeparator) {
      valuesSeparator = CSVUtils.VALUES_SEPARATOR;
    }
    if (!lineSeparator) {
      lineSeparator = CSVUtils.LINES_SEPARATOR;
    }
    let i: number = 0;
    while (i < contentObjectArray.length) {
      content += this.createLineStringFromObject(contentObjectArray[i], contentPropertyNamesArray, valuesSeparator, lineSeparator, useQuotationMarksForStrings);
      i++;
    }
    return content;
  }

  public static createLineStringFromArray(contentArray: any, valuesSeparator: string = null, lineSeparator: string = null, useQuotationMarksForStrings: boolean = false): string {
    let line = '';
    if (!contentArray) {
      return line;
    }
    if (!valuesSeparator) {
      valuesSeparator = CSVUtils.VALUES_SEPARATOR;
    }
    if (!lineSeparator) {
      lineSeparator = CSVUtils.LINES_SEPARATOR;
    }
    let i: number = 0;
    while (i < contentArray.length) {
      if (i > 0) {
        line += valuesSeparator;
      }
      if (!this.isNullOrUndefined(contentArray[i])) {
        if (useQuotationMarksForStrings && (typeof contentArray[i] === 'string' || contentArray[i] instanceof String)) {
          line += '"' + contentArray[i].toString() + '"';
        } else {
          line += contentArray[i].toString();
        }
      }
      i++;
    }
    line += lineSeparator;
    return line;

  }

  public static createLineStringFromObject(contentObject: any, contentPropertyNamesArray: string[], valuesSeparator: string = null,
    lineSeparator: string = null, useQuotationMarksForStrings: boolean = false): string {
    let line: string = '';
    if (this.isNullOrUndefined(contentObject) || !contentPropertyNamesArray) {
      return line;
    }
    if (!valuesSeparator) {
      valuesSeparator = CSVUtils.VALUES_SEPARATOR;
    }
    if (!lineSeparator) {
      lineSeparator = CSVUtils.LINES_SEPARATOR;
    }
    let i: number = 0;
    while (i < contentPropertyNamesArray.length) {
      const propertyName: string = contentPropertyNamesArray[i];
      if (propertyName && contentObject.hasOwnProperty(propertyName) && !this.isNullOrUndefined(contentObject[propertyName])) {
        if (i > 0) {
          line += valuesSeparator;
        }
        if (useQuotationMarksForStrings && (typeof contentObject[propertyName] === 'string' || contentObject[propertyName] instanceof String)) {
          line += '"' + contentObject[propertyName].toString() + '"';
        } else {
          line += contentObject[propertyName].toString();
        }
      } else if (i > 0) {
        line += valuesSeparator;
      }
      i++;
    }
    line += lineSeparator;
    return line;
  }

  private static isNullOrUndefined(object: any): boolean {
    return object === null || object === undefined;
  }
}
